<template>
  <Teleport to="body">
    <Transition name="chart-setup-overlay">
      <div
        v-if="show"
        class="chart-setup-modal-overlay chart-setup-modal-overlay--glass"
        role="dialog"
        aria-modal="true"
        aria-labelledby="chart-setup-title"
        @click.self="handleSkip"
      >
        <div class="chart-setup-modal chart-setup-modal--glass" @click.stop>
          <div class="chart-setup-header chart-setup-header--glass">
            <h3 id="chart-setup-title" class="chart-setup-title">
              <i class="bi bi-file-earmark-spreadsheet" aria-hidden="true"></i>
              Set Up Your Chart of Accounts
            </h3>
          </div>

          <div class="chart-setup-body chart-setup-body--glass">
            <div class="chart-setup-icon">
              <i class="bi bi-file-earmark-text" aria-hidden="true"></i>
            </div>

            <div class="chart-setup-content">
              <h4 class="chart-setup-main-message">Welcome to Your New Company!</h4>
              <p class="chart-setup-description">
                To get started with proper accounting, you need to set up your Chart of Accounts.
                This will create
                <strong>{{ totalAccounts }}</strong>
                predefined accounts organized by category.
              </p>

              <div class="chart-setup-benefits">
                <div class="benefit-item">
                  <i class="bi bi-check-circle-fill" aria-hidden="true"></i>
                  <span>Organized accounting structure</span>
                </div>
                <div class="benefit-item">
                  <i class="bi bi-check-circle-fill" aria-hidden="true"></i>
                  <span>Pre-configured asset, liability, and equity accounts</span>
                </div>
                <div class="benefit-item">
                  <i class="bi bi-check-circle-fill" aria-hidden="true"></i>
                  <span>Revenue and expense categories ready to use</span>
                </div>
                <div class="benefit-item">
                  <i class="bi bi-check-circle-fill" aria-hidden="true"></i>
                  <span>Compliant with standard accounting practices</span>
                </div>
              </div>

              <div class="chart-setup-warning" role="note">
                <i class="bi bi-exclamation-triangle" aria-hidden="true"></i>
                <span>
                  <strong>Important:</strong>
                  Without a Chart of Accounts, you won't be able to properly track your business
                  finances, transactions, and generate accurate financial reports.
                </span>
              </div>
            </div>
          </div>

          <div class="chart-setup-footer chart-setup-footer--glass">
            <SecondaryButton
              label="Skip for Now"
              icon="bi bi-x-circle"
              :disabled="isLoading"
              @click="handleSkip"
            />
            <PrimaryButton
              :label="loadChartLabel"
              icon="bi bi-arrow-clockwise"
              :disabled="isLoading"
              :loading="isLoading"
              @click="handleLoadChart"
            />
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script>
import './ChartOfAccountsSetupModal.css';
import PrimaryButton from '@/modules/consultant/components/PrimaryButton.vue';
import SecondaryButton from '@/modules/consultant/components/SecondaryButton.vue';

export default {
  name: 'ChartOfAccountsSetupModal',
  components: {
    PrimaryButton,
    SecondaryButton,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    totalAccounts: {
      type: Number,
      default: 60,
    },
  },
  emits: ['close', 'load-chart', 'skip'],
  computed: {
    loadChartLabel() {
      return this.isLoading ? 'Loading...' : 'Load Chart of Accounts';
    },
  },
  methods: {
    handleLoadChart() {
      this.$emit('load-chart');
    },
    handleSkip() {
      this.$emit('skip');
    },
  },
};
</script>
